<section class="home-dashboard" aria-labelledby="dashboard-title">
	<div class="home-dashboard__surface">
		<img class="home-dashboard__logo" src="assets/img/chevron-logo.png" alt="Chevron" />
		<div class="home-dashboard__heading">
			<p>Welcome to</p>
			<h1 id="dashboard-title">Permian Constraint Modeling Program</h1>
			<!-- <span>Choose an application to access its dashboard</span> -->
		</div>

		<nav class="application-grid" aria-label="Applications">
			<a class="application-tile" routerLink="/aggregator">
				<span class="application-tile__icon">
					<img src="assets/img/Aggregator.png" alt="" />
				</span>
				<span class="application-tile__title">CMP Aggregator Dashboard</span>
				<span class="application-tile__description">Aggregate capacity values across all streams for planning and forecast review.</span>
				<span class="application-tile__action">Open Aggregator <span aria-hidden="true">&rarr;</span></span>
			</a>

			<a class="application-tile" routerLink="/outlook">
				<span class="application-tile__icon">
					<img src="assets/img/Outlook_icon.png" alt="" />
				</span>
				<span class="application-tile__title">CMP Outlook Dashboard</span>
				<span class="application-tile__description">Displays production forecasts across FE, oil, gas, and water.</span>
				<span class="application-tile__action">Open Outlook <span aria-hidden="true">&rarr;</span></span>
			</a>

			<a class="application-tile" routerLink="/fe">
				<span class="application-tile__icon">
					<img src="assets/img/outlook.png" alt="" />
				</span>
				<span class="application-tile__title">Capacities Database</span>
				<span class="application-tile__description">Manage the facility capacity and mapping system of record.</span>
				<span class="application-tile__action">Open Capacities Database <span aria-hidden="true">&rarr;</span></span>
			</a>
		</nav>
	</div>
</section>
